import { render } from "./pb-donate.vue?vue&type=template&id=52cbc099"
import script from "./pb-donate.vue?vue&type=script&lang=js"
export * from "./pb-donate.vue?vue&type=script&lang=js"

import "./pb-donate.vue?vue&type=style&index=0&id=52cbc099&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__